<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-row>
        <b-col md="12">
          <h1 class="display-3">Gestion des dossiers</h1>
        </b-col>
      </b-row>
      <b-row v-if="canAccesDashboard()">
        <b-col md="12">
          <!-- <dashboard-qualification v-if="canAccessDashboardQualification()"></dashboard-qualification> -->
          <dashboard-gestion v-if="canAccesDashboard()"></dashboard-gestion>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <transition name="fade">
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapseRecherche>
                <i class="fa fa-search mr-2"></i>
                <strong>Recherche</strong>
                <div class="card-header-actions">
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                </div>
              </div>
              <b-collapse id="collapseRecherche">
                <b-card-body class="small-padding">

                  <b-form v-on:submit.prevent="search">
                    <span class="field-error">{{ errors.critere }}</span>
                    <b-row>
                      <b-col sm="6" class="border-right">
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="date_du"><strong>Date de réception du</strong></label>
                          </b-col>
                          <b-col sm="4">
                            <b-form-input class="input_date" type="date" id="date_du" size="sm" v-model="date_du"></b-form-input>
                          </b-col>
                          <b-col sm="1">
                            <label for="date_au"><strong>Au</strong></label>
                          </b-col>
                          <b-col sm="4">
                            <b-form-input class="input_date" type="date" id="date_au" size="sm" v-model="date_au"></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="gestionnaire"><strong>Traitement voulu : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <b-form-select v-model="selectedTraitementId" :options="traitementsOptions" :class="{hasError: errors.traitement !== ''}">
                              <template v-slot:first>
                                <b-form-select-option :value="''" disabled>-- Choisir un traitement --</b-form-select-option>
                              </template>
                            </b-form-select>
                            <span class="field-error inline mr-1 float-right">{{ errors.traitement }}</span>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1" v-if="displayDateSinistre">
                          <b-col sm="3">
                            <label for="date_sinistre_du"><strong>Date du sinistre du :</strong></label>
                          </b-col>
                          <b-col sm="3">
                            <b-form-input class="input_date" type="date" id="date_sinistre_du" size="sm" v-model="date_sinistre_du"></b-form-input>
                          </b-col>
                          <b-col sm="1">
                            <label for="date_sinistre_au"><strong>Au :</strong></label>
                          </b-col>
                          <b-col sm="3">
                            <b-form-input class="input_date" type="date" id="date_sinistre_au" size="sm" v-model="date_sinistre_au"></b-form-input>
                          </b-col>
                          <b-col sm="2" style="margin-top:2px;">
                            <span style="display:table-cell;vertical-align:middle;">
                              <strong style="margin-right:5px">exclus</strong>
                            </span>
                            <span style="display:table-cell;vertical-align:middle;">
                              <b-form-checkbox v-model="exclureDateSinistre" style="margin-left:5px"></b-form-checkbox>
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="nom"><strong>Nom : </strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="nom" v-model="nom" placeholder=""></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="prenom"><strong>Prenom : </strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="prenom" v-model="prenom" placeholder=""></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="nir"><strong>NIR :</strong></label>
                          </b-col>
                          <b-col sm="4">
                              <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..."></b-form-input>
                          </b-col>
                          <b-col sm="2">
                            <label for="idpp"><strong>IDPP :</strong></label>
                          </b-col>
                          <b-col sm="3">
                              <b-form-input type="text" id="idpp" v-model="idpp" placeholder="N° NSI"></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="type"><strong>Type : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="type" tag-placeholder="Choisissez un type" placeholder="Choisissez un type" label="name" track-by="code" :options="allTypes" :multiple="true" :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="gestionnaire"><strong>Statut du dossier : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="status" tag-placeholder="Choisissez un status" placeholder="Par défaut Tous" label="name" track-by="code" :options="allStatusOption" :multiple="true" :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="gestionnaire"><strong>Sous Statut : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="sousStatus" tag-placeholder="Choisissez un status" placeholder="Par défaut Tous" label="name" track-by="code" :options="allSousStatusOption" :multiple="true" :taggable="true" :disabled="status.length !== 1"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label><strong>Statut Prest'IJ : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="statusPrestij"
                                         tag-placeholder="Choisissez un status prest ij"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         :options="allStatusPrestij"
                                         :multiple="true"
                                         :taggable="true">
                            </multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="rar"><strong>N° RAR :</strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="rar" v-model="rar" placeholder=""></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="dossierIds"><strong>N° Dossier(s) :</strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="dossierIds" v-model="dossierIds" placeholder="Numéros séparés par virgule ','"></b-form-input>
                              <span class="field-error inline mr-1 float-right">{{ errors.dossierIds }}</span>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="flag"><strong>Flag : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                              selectedLabel='Sélectionné'
                              deselectLabel='Appuyer sur entrer pour désélectionner'
                              :close-on-select="false"
                              v-model="flag"
                              tag-placeholder="Choisissez un flag"
                              placeholder="Choisissez un flag"
                              label="name"
                              track-by="code"
                              :options="flagOptions"
                              :multiple="true"
                              :taggable="true">
                            </multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="typeUrgence"><strong>Type Urgence :</strong></label>
                          </b-col>
                          <b-col sm="9">
                               <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                              selectedLabel='Sélectionné'
                              deselectLabel='Appuyer sur entrer pour désélectionner'
                              :close-on-select="false"
                              v-model="typeUrgence"
                              tag-placeholder="Choisissez un type"
                              placeholder="Choisissez un type"
                              label="name"
                              track-by="code"
                              :options="typeUrgenceOptions"
                              :multiple="true"
                              :taggable="true">
                            </multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="rar"><strong>Règle de cumul</strong><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-rc"></i></label>
                              <b-tooltip target="tooltip-rc" triggers="hover">
                                Règle de cumul détecté
                              </b-tooltip>
                          </b-col>
                          <b-col sm="9">
                            <b-form-group>
                              <b-form-select v-model="regleCumul" :options="allRegleCumulOption">
                              <template v-slot:first>
                                <b-form-select-option :value="''" >-- Choisir une règle --</b-form-select-option>
                              </template>
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="nomBeneficiaire"><strong>Nom bénéficiaire (fiche décès) :</strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="nomBeneficiaire" v-model="nomBeneficiaire" placeholder=""></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col sm="6">
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label><strong>SIREN : </strong></label>
                          </b-col>
                          <b-col sm="4">
                            <b-form-input type="text" placeholder="Saisir un SIREN" id="siren" v-model="siren"></b-form-input>
                          </b-col>
                          <b-col sm="2">
                            <label for="nic"><strong>NIC :</strong></label>
                          </b-col>
                          <b-col sm="3">
                              <b-form-input type="text" id="nic" v-model="nic" placeholder="Saisir un NIC"></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label><strong>Groupe Siren : </strong></label>
                          </b-col>
                          <b-col sm="6">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="groupSirens"
                                         tag-placeholder="Choisissez un groupe de siren"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         :options="allGroupSirens"
                                         :multiple="true"
                                         :taggable="true">
                            </multiselect>
                          </b-col>
                          <b-col sm="3" style="margin-top:10px;">
                            <span style="display:table-cell;vertical-align:middle;">
                              <strong style="margin-right: 10px">exclus</strong>
                            </span>
                            <span style="display:table-cell;vertical-align:middle;">
                              <b-form-checkbox v-model="exclureGroupeSiren" style="margin-right: 10px"></b-form-checkbox>
                            </span>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="canal"><strong>Canal : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="canal" tag-placeholder="Choisissez un canal" placeholder="Choisissez un canal" label="name" track-by="code" :options="allCanalsOptions" :multiple="true" :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="segment"><strong>Segment : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="segment" tag-placeholder="Choisissez un segment" placeholder="Choisissez un segment" label="name" track-by="code" :options="allSegments" :multiple="true" :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="produit"><strong>Famille produit : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" v-model="produit" tag-placeholder="Choisissez un produit" placeholder="Choisissez un produit" label="name" track-by="code" :options="optionsProduit" :multiple="true" :taggable="true" group-values="produits" group-label="secteur"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col sm="3">
                            <label for="gestionnaire"><strong>Gestionnaire affecté : </strong></label>
                          </b-col>
                          <b-col sm="9">
                              <!-- <b-form-input type="text" id="gestionnaire" v-model="gestionnaire" placeholder=""></b-form-input> -->
                              <auto-select
                                v-model="gestionnaire"
                                :items="gestionnaires"
                                :loading="loadingGestionnaire"
                                item-value="id"
                                item-text="nom"
                                id="gestionnaire"
                                :placeholder="gestionnaire ? '' : 'Entrer le nom du gestionnaire'"
                                disable-filtering-by-search
                                @search="onSearchGestionnaire"
                                v-on:keyup.enter="onEnter()"
                              >
                                <template #no-data>
                                  {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
                                </template>
                                <template slot="item" slot-scope="{ item: gest }">
                                  <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                                    <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                                  </div>
                                </template>
                                <template slot="selection" slot-scope="{ item: gest }">
                                  <div style="display: flex; align-items: center;">
                                    <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                                  </div>
                                </template>
                                <template v-if="loadingGestionnaire" #input-end>
                                  <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                                </template>
                              </auto-select>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label><strong>Segment Commercial : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="segmentsCommerciaux"
                                         tag-placeholder="Choisissez un segment commercial"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         :options="allSegmentsCommerciaux"
                                         :multiple="true"
                                         :taggable="true">
                            </multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label><strong>Délégation Commerciale : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="delegations"
                                         tag-placeholder="Choisissez une délégation"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         :options="allDelegations"
                                         :multiple="true"
                                         :taggable="true">
                            </multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="campagne"><strong>Campagne Qualité : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="campagnes"
                                         tag-placeholder="Choisissez une campagne"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         id="campagne"
                                         :options="allCampagnes" :multiple="true"
                                         :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="oag"><strong>OAG : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="oags"
                                         tag-placeholder="Choisissez un OAG"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         id="oag"
                                         :options="oagOptions" :multiple="true"
                                         :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="oap"><strong>OAP : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="oaps"
                                         tag-placeholder="Choisissez un OAP"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         id="oap"
                                         :options="oapOptions" :multiple="true"
                                         :taggable="true"></multiselect>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="selectedTeam"><strong>Equipe affectée : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <b-form-select id="selectedTeam" v-model="selectedTeam" :options="teamOptions">
                              <template v-slot:first>
                                <b-form-select-option :value="''" >-- Choisir une équipe --</b-form-select-option>
                              </template>
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="nbDossierNir"><strong>Dossiers ouverts par NIR : </strong></label>
                          </b-col>
                          <b-col sm="9">
                            <div style="display:table;">
                            <b-form-input style="width:150px; display:table-cell;vertical-align:middle;margin-right: 10px;" v-model="nbDossierNir" id="nbDossierNir" type="range" min="0" max="50" step="5">
                            </b-form-input>
                            <span style="display:table-cell;vertical-align:middle;">
                              <b-badge style="margin-right: 20px" pill variant="success">{{ displayNbDossierNir() }}</b-badge>
                            </span>
                            <span style="display:table-cell;vertical-align:middle;">
                              <strong style="margin-right: 10px">hors BPIJ</strong>
                            </span>
                            <span style="display:table-cell;vertical-align:middle;">
                              <b-form-checkbox v-model="exclureBpij" style="margin-right: 10px"></b-form-checkbox>
                            </span>
                          </div>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="typePopulation"><strong>Type population</strong><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-type-population"></i></label>
                              <b-tooltip target="tooltip-type-population" triggers="hover">
                                S'applique uniquement pour les dossiers canal CeV
                              </b-tooltip>
                          </b-col>
                          <b-col sm="9">
                            <b-form-group>
                              <b-form-select v-model="typePopulation" :options="allTypePopulationOption">
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="numeroEvenementNsi"><strong>N° Evenement NSI : </strong></label>
                          </b-col>
                          <b-col sm="9">
                              <b-form-input type="text" id="numeroEvenementNsi" v-model="numeroEvenementNsi" placeholder=""></b-form-input>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="">
                          <b-col sm="3">
                            <label for="affiliation"><strong>Affiliation Salarié</strong></label>
                          </b-col>
                          <b-col sm="9">
                            <b-form-group>
                              <b-form-select v-model="typeAffiliationSalarie" :options="allTypeAffiliationSalarieOption">
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row v-show="advancedSearch" class="mb-1">
                          <b-col sm="3">
                            <label for="affiliation"><strong>Code PTZ</strong></label>
                          </b-col>
                          <b-col sm="9">
                            <b-form-group>
                              <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                         selectedLabel='Sélectionné'
                                         deselectLabel='Appuyer sur entrer pour désélectionner'
                                         :close-on-select="false"
                                         v-model="codesPtz"
                                         tag-placeholder="Choisissez un OAP"
                                         placeholder="Par défaut Tous"
                                         label="name"
                                         track-by="code"
                                         id="oap"
                                         :options="codePtzOptions" :multiple="true"
                                         :taggable="true"></multiselect>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Fin Partie dupliquée dans gestion corbeille -->
                    <div class="footer borded-top mt-1">
                      <b-button v-if="canCreateBasket()" type="button" @click.prevent="save()" size="md" variant="success" class="">
                        <i class="fa fa-save"></i> Créer une corbeille
                      </b-button>

                      <!-- <b-form-input class="float-left mb-1 mr-1" type="text" id="basketName" v-model="basketName" placeholder=""></b-form-input> -->

                      <b-button class="float-right mb-1" type="enter" @click.prevent="search()" size="md" variant="primary">
                        <i class="fa fa-search"></i> Rechercher
                      </b-button>
                      <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1 mb-1 float-right">
                        <i class="fa fa-eraser"></i> Effacer
                      </b-button>
                      <b-button class="mr-1 float-right mb-1" type="enter" @click.prevent="toggleAdvancedSearch()" size="md" variant="link">
                        <i v-bind:class="[advancedSearch ? 'fa fa-minus' : 'fa fa-plus']"></i> {{ advancedSearch ? 'Voir moins de critères' : 'Voir plus de critères' }}
                      </b-button>
                    </div>
                  </b-form>
                </b-card-body>
              </b-collapse>
              <!-- <b-collapse  id="collapseRecherche">
                <b-card-body class="small-padding">

                </b-card-body>
              </b-collapse> -->
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <dossier-table :tableEntry="tableParam" ref="dashboard_dossier_table"></dossier-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules, rules as adminRules } from "@/utils/rulesHelper"
import dashboardQualification from "@/components/Dossier/DashboardDossierQualification"
import dashboardGestion from "@/components/Dossier/DashboardDossierGestion"
import dossierTable from "@/components/Dossier/DossierTable"
import Multiselect from 'vue-multiselect'
import { CoolSelect as AutoSelect } from 'vue-cool-select'
import {isEmpty} from "@/utils/fileHelper";
import {canSeeCritere} from "@/utils/communHelper";

export default {
  components: {
    Multiselect,
    dossierTable,
    AutoSelect,
    dashboardQualification,
    dashboardGestion,
  },
  data() {
    return {
      optionsProduit: [],
      canSeeCritere,
      fromDashboard: "",
      balId: '',
      modeVisualisation: 'monActiviteProd',
      basketId: '',
      statusId: null,
      statusIds: [],
      nir: '',
      idpp: '',
      gestionnaire: '',
      gestionnaireNom: '',
      gestionnairePrenom: '',
      gestionnaires: [],
      loadingGestionnaire: false,
      timeoutId: null,
      noData: false,
      date_du: '',
      date_au: '',
      displayDateSinistre: false,
      date_sinistre_du: '',
      date_sinistre_au: '',
      nom: '',
      prenom: '',
      rar: '',
      produit: [],
      allProduits: [],
      selectedProduits: [],
      segment: [],
      allSegments: [],
      selectedSegments: [],
      canal: [],
      allCanals: [],
      allCanalsOptions: [],
      selectedCanals: [],
      type: [],
      allTypes: [],
      selectedTypes: [],
      traitementId: '',
      selectedTraitementId: '',
      traitementsOptions: [],
      allTraitements: [],
      alerte: '',
      // statusTraite: '',
      status: [],
      allStatus: [],
      allStatusOption: [],
      selectedStatus: [],
      sousStatus: [],
      allSousStatusOption: [],
      selectedSousStatus: [],
      statusPrestij: [],
      allStatusPrestij: [],
      selectedStatusPrestij: [],
      segmentsCommerciaux: [],
      allSegmentsCommerciaux: [],
      selectedSegmentsCommerciaux: [],
      delegations: [],
      allDelegations: [],
      selectedDelegations: [],
      groupSirens: [],
      allGroupSirens: [],
      selectedGroupSirens: [],
      campagnes: [],
      allCampagnes: [],
      selectedCampagnes: [],
      delai_traitement: 0,
      delai_en_attente: 0,
      siren: '',
      nic: '',
      dossierIds: '',
      contactEmail: '',
      oags: [],
      allOags: [],
      oagOptions: [],
      selectedOags: [],
      oaps: [],
      allOaps: [],
      oapOptions: [],
      selectedOaps: [],
      allTeams: [],
      teamOptions: [],
      selectedTeam: '',
      onlyOneCritere: false,
      codesPtz: [],
      allCodePtz: [],
      codePtzOptions: [],
      selectedCodePtz: [],
      noSearch: "noSearch",
      errors: { critere: '', traitement: '' },
      allRegleCumulOption: [],
      regleCumul: '',
      nomBeneficiaire: '',
      allTypePopulationOption: [{ value : 'Tous', text : 'Tous'}, { value : 'CA', text : 'Cadre'}, { value : 'NC', text : 'Non Cadre'}],
      typePopulation: 'Tous',
      allTypeAffiliationSalarieOption: [{ value : 'Tous', text : 'Tous'}, { value : 'MonoSiren', text : 'Mono SIREN'}, { value : 'MultiSiren', text : 'Multi SIREN'}],
      typeAffiliationSalarie: 'Tous',
      nbDossierNir: 0,
      exclureBpij:'',
      allFlags: [],
      flag: [],
      flagOptions: [],
      selectedFlags: [],
      allTypesUrgence: [],
      typeUrgence: [],
      typeUrgenceOptions: [{ code : 'urgences_directions', name : 'Urgences Directions'}, { code : 'lignes_rouges', name : 'Lignes Rouges'}, { code : 'fiche_telephonique', name : 'Fiche Tél Webhelp'}, { code : 'mog', name : 'MOG'}],
      selectedTypesUrgences: [],
      exclureGroupeSiren: '',
      exclureDateSinistre: '',
      numeroEvenementNsi: '',
      advancedSearch: false
    }
  },
  computed: {
    tableParam: {
      get() {
        let request = {};
        // console.log('dans dashboard: ',this.basketId,this.alerte)
        request.fromDashboard = this.fromDashboard;
        request.balId = this.balId;
        request.basketId = this.basketId;
        request.statusId = this.statusId;
        request.nir = this.nir.replace(/ /g, "");
        this.nir = request.nir;
        request.id_pp = this.idpp;
        request.gestionnaire = this.gestionnaire;
        request.date_du = this.date_du;
        request.date_au = this.date_au;
        request.date_sinistre_du = this.date_sinistre_du;
        request.date_sinistre_au = this.date_sinistre_au;
        request.rar = this.rar;
        request.nom = this.nom;
        request.prenom = this.prenom;
        request.noSearch = this.noSearch;
        request.siren = this.siren;
        request.nic = this.nic;
        request.segment = this.selectedSegments;
        request.canal = this.selectedCanals;
        request.type = this.selectedTypes;
        request.produit = this.selectedProduits;
        request.status_prestij = this.selectedStatusPrestij;
        request.segmentsCommerciaux = this.selectedSegmentsCommerciaux;
        request.traitementId = this.selectedTraitementId;
        // request.traitementId = this.traitementId;
        // request.statusTraite = this.statusTraite;
        request.modeVisualisation = this.modeVisualisation;
        request.alerte = this.alerte;
        request.dossierIds = this.dossierIds;
        request.typeUrgence = this.selectedTypesUrgences;
        request.oags = this.selectedOags;
        request.oaps = this.selectedOaps;
        request.selectedTeam = this.selectedTeam;
        request.campagnes = this.selectedCampagnes;
        request.onlyOneCritere = this.onlyOneCritere;
        request.contactEmail = this.contactEmail;
        request.regleCumul = this.regleCumul;
        request.nomBeneficiaire = this.nomBeneficiaire;
        request.typePopulation = this.typePopulation;
        request.typeAffiliationSalarie = this.typeAffiliationSalarie;
        request.nbDossierNir = this.nbDossierNir;
        request.exclureBpij = this.exclureBpij;
        request.flag = this.selectedFlags;
        request.exclureGroupeSiren = this.exclureGroupeSiren;
        request.exclureDateSinistre = this.exclureDateSinistre;
        request.numeroEvenementNsi = this.numeroEvenementNsi;
        return request;
      }
    },
  },
  watch: {
    selectedTraitementId: function(){
      this.displayDateSinistre = false;
      if(this.selectedTraitementId){

       // let traitementsEligiblesLibelles = ['gestion_dc','ij_gestion_prestation','ij_module_prevoyance','gestion_inval'];

        //let traitementEligibles = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc' || traitement.libelle_technique === 'ij_gestion_prestation');
        let traitementDeces = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc');
        let traitementInval = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_inval');
        let traitementIj = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_gestion_prestation');
        let traitementIjModulePrev = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_module_prevoyance');
        //let traitementEligibles = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc' || traitement.libelle_technique === 'ij_gestion_prestation');

        if(this.selectedTraitementId === traitementDeces.id
          || this.selectedTraitementId === traitementInval.id
          || this.selectedTraitementId === traitementIj.id
          || this.selectedTraitementId === traitementIjModulePrev.id){
          this.displayDateSinistre = true;
        }else{
          this.date_sinistre_du = '';
          this.date_sinistre_au = '';
        }
      }
    },
    status: function() {
      if (this.status) {
        this.selectedStatus = this.status.map( item => item.code);
        // Au changement du statut parent on efface les sous-statuts précédement sélectionnés
        this.selectedSousStatus = [];
        this.sousStatus = [];
        this.getSousStatus();
      } else {
        this.selectedStatus = [];
      }
    },
    sousStatus: function() {
      if (this.sousStatus) {
        this.selectedSousStatus = this.sousStatus.map( item => item.code)
      } else {
        this.selectedSousStatus = []
      }
    },
    canal: function() {
      if (!isEmpty(this.canal)) {
        this.selectedCanals = this.canal.map( item => item.code);
        // S'il n'y a pas le canal de CEV de sélectionné, on passe le type de population à tous
        let findCanalCev = false;
        for (let canalOption of this.canal) {
          let canal = this.allCanals.find( item => item.id === canalOption.code);
          if (canal && canal.libelle_technique === 'cev') {
            findCanalCev = true;
            break;
          }
        }
        if (!findCanalCev) {
          this.typePopulation = 'Tous';
        }
      } else {
        this.selectedCanals = []
        // S'il n'y a pas de canal de sélectionné le type de population est forcément "Tous"
        this.typePopulation = 'Tous';
      }

    },
    type: function() {
      if (this.type) {
        this.selectedTypes = this.type.map( item => item.code)
      } else {
        this.selectedTypes = []
      }
    },
    segment: function() {
      if (this.segment) {
        this.selectedSegments = this.segment.map( item => item.code)
      } else {
        this.selectedSegments = []
      }
    },
    produit: function() {
      if (this.produit) {
        this.selectedProduits = this.produit.map( item => item.code)
      } else {
        this.selectedProduits = []
      }
    },
    statusPrestij: function () {
      if (this.statusPrestij) {
        this.selectedStatusPrestij = this.statusPrestij.map(item => item.code);
        // console.log('dans watcher, this.selectedStatusPrestij', this.selectedStatusPrestij)
      } else {
        this.selectedStatusPrestij = [];
      }
    },
    delegations: function () {
      if (this.delegations) {
        this.selectedDelegations = this.delegations.map(item => item.code);
      } else {
        this.selectedDelegations = [];
      }
    },
    segmentsCommerciaux: function () {
      if (this.segmentsCommerciaux) {
        this.selectedSegmentsCommerciaux = this.segmentsCommerciaux.map(item => item.code);
      } else {
        this.selectedSegmentsCommerciaux = [];
      }
    },
    groupSirens: function () {
      if (this.groupSirens) {
        this.selectedGroupSirens = this.groupSirens.map(item => item.code);
      } else {
        this.selectedGroupSirens = [];
      }
    },
    campagnes: function () {
      if (this.campagnes) {
        this.selectedCampagnes = this.campagnes.map(item => item.code);
      } else {
        this.selectedCampagnes = [];
      }
    },
    oags: function () {
      if (this.oags) {
        this.selectedOags = this.oags.map(item => item.code);
      } else {
        this.selectedOags = [];
      }
    },
    oaps: function () {
      if (this.oaps) {
        this.selectedOaps = this.oaps.map(item => item.code);
      } else {
        this.selectedOaps = [];
      }
    },
    codesPtz: function () {
      if (this.codesPtz) {
        this.selectedCodePtz = this.codesPtz.map(item => item.code);
      } else {
        this.selectedCodePtz = [];
      }
    },
    flag: function() {
      if (this.flag) {
        this.selectedFlags = this.flag.map( item => item.code)
      } else {
        this.selectedFlags = []
      }
    },
    typeUrgence: function() {
      if (this.typeUrgence) {
        this.selectedTypesUrgences = this.typeUrgence.map( item => item.code)
      } else {
        this.selectedTypesUrgences = []
      }
    },
    typePopulation () {
      if (this.typePopulation !== 'Tous') {
        let canalCev = this.allCanals.find( item => item.libelle_technique === 'cev' );
        let CanalCevOption = this.allCanalsOptions.find( item => item.code === canalCev.id );
        this.canal = [CanalCevOption];
      }
    },
  },
  async created() {
  },
  async mounted() {
    await this.getDataInputSerach()
    // repeuplement du form suite retour d'une fiche
    this.populateSegment();
    this.populateType();
    this.populateCanal();
    this.populateProduit();
    this.populateStatus();
    this.populateSousStatus();
    this.populateDelegation();
    this.populateSegmentCommerciaux();
    this.populateGroupSiren();
    this.populateStatusPrestij();
    this.populateCampagne();
    this.populateOags();
    this.populateOaps();
    this.getReglesCumul();
    this.populateFlag();
    this.populateTypeUrgence();
    this.populateCodePtz();

    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()

    // let queries = _.clone(this.$route.query);
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateStatus()
      await this.getSousStatus()
    }
    if (this.$route.query.sousStatus) {
      this.selectedSousStatus = this.$route.query.sousStatus
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateSousStatus()
    }
    if (this.$route.query.nir) {
      this.nir = this.$route.query.nir
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.idpp) {
      this.idpp = this.$route.query.idpp
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.gest) {
      this.gestionnaire = this.$route.query.gest
      this.gestionnaireNom = this.$route.query.gestNom
      this.gestionnairePrenom = this.$route.query.gestPrenom
      this.gestionnaires.push({id: this.gestionnaire, nom: this.gestionnaireNom, prenom: this.gestionnairePrenom})
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.bal) {
      this.balId = this.$route.query.bal
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.basketId) {
      this.basketId = this.$route.query.basketId
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.dd) {
      this.date_du = this.$route.query.dd
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.da) {
      this.date_au = this.$route.query.da
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.dsd) {
      this.date_sinistre_du = this.$route.query.dsd
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.dsa) {
      this.date_sinistre_au = this.$route.query.dda
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.nom) {
      this.nom = this.$route.query.nom
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.prenom) {
      this.prenom = this.$route.query.prenom
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.rar) {
      this.rar = this.$route.query.rar
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.siren) {
      this.siren = this.$route.query.siren
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.nic) {
      this.nic = this.$route.query.nic
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.statusPrestij) {
      this.selectedStatusPrestij = this.$route.query.statusPrestij
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateStatusPrestij()
    }
    if (this.$route.query.segment) {
      this.selectedSegments = this.$route.query.segment
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateSegment()
    }
    if (this.$route.query.segmentCom) {
      this.selectedSegmentsCommerciaux = this.$route.query.segmentCom
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateSegmentCommerciaux()
    }
    if (this.$route.query.delegations) {
      this.selectedDelegations = this.$route.query.delegations
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateDelegation()
    }
    if (this.$route.query.type) {
      this.selectedTypes = this.$route.query.type
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateType()
    }
    if (this.$route.query.canal) {
      this.selectedCanals = this.$route.query.canal
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateCanal()
    }
    if (this.$route.query.produit) {
      this.selectedProduits = this.$route.query.produit
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateProduit()
    }
    if (this.$route.query.campagnes) {
      this.selectedCampagnes = this.$route.query.campagnes
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateCampagne()
    }
    if (this.$route.query.groupeSiren) {
      this.selectedGroupSirens = this.$route.query.groupeSiren
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateGroupSiren()
    }
    if (this.$route.query.oags) {
      this.selectedOags = this.$route.query.oags
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateOags()
    }
    if (this.$route.query.oaps) {
      this.selectedOaps = this.$route.query.oaps
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateOaps()
    }
    if (this.$route.query.team) {
      this.selectedTeam = this.$route.query.team
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.traitementId) {
      this.traitementId = this.$route.query.traitementId
      this.selectedTraitementId = this.$route.query.traitementId
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.fromDashboard) {
      this.fromDashboard = this.$route.query.fromDashboard
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.modeVisualisation) {
      this.modeVisualisation = this.$route.query.modeVisualisation
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.$event.emit('changeModeVisualisation', this.modeVisualisation)
    }
    if (this.$route.query.alerte) {
      this.alerte = this.$route.query.alerte
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.bals) {
      this.selectedBals = this.$route.query.bals
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.dossierIds) {
      this.dossierIds = this.$route.query.dossierIds
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.typeUrgence) {
      this.selectedTypesUrgences = this.$route.query.typeUrgence;
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search';
      this.populateTypeUrgence();
    }
    if (this.$route.query.onlyOneCritere) {
      this.onlyOneCritere = this.$route.query.onlyOneCritere
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.regleCumul) {
      this.regleCumul = this.$route.query.regleCumul
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.nomBeneficiaire) {
      this.nomBeneficiaire = this.$route.query.nomBeneficiaire
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.typePopulation) {
      this.typePopulation = this.$route.query.typePopulation
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.typeAffiliationSalarie) {
      this.typeAffiliationSalarie = this.$route.query.typeAffiliationSalarie
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.exclureBpij) {
      this.exclureBpij = this.$route.query.exclureBpij
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.flag) {
      this.selectedFlags = this.$route.query.flag
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
      this.populateFlag()
    }
    if (this.$route.query.exclureGroupeSiren) {
      this.exclureGroupeSiren = this.$route.query.exclureGroupeSiren
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }
    if (this.$route.query.exclureDateSinistre) {
      this.exclureDateSinistre = this.$route.query.exclureDateSinistre
      this.noSearch = this.$route.query.fromDashboard && this.$route.query.fromDashboard === 'fromDashboard' ? '' : 'search'
    }


    if (!isEmpty(this.$route.query)) {
      // si la query url n'est pas vide il faut lancer la recherche
      this.$refs.dashboard_dossier_table.$refs.table.refresh();
      this.$router.replace({ query: {} })
    }

    this.$eventBus.$on('setAdvancedSearch', (value) => {
      this.advancedSearch = value
    })

  },
  methods: {
    nameWithProfile({name, profile}) {
      return `${name} — [${profile}]`
    },
    onClick(event, item){
      this.gestionnaireNom = item.nom
      this.gestionnairePrenom = item.prenom
    },
    onEnter(){
      for(let gest of this.gestionnaires) {
        if (this.gestionnaire === gest.id) {
          this.gestionnaireNom = gest.nom
          this.gestionnairePrenom = gest.prenom
        }
      }
    },
    async getDataInputSerach() {
      let self = this;
      // this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/espaceGestion/dossier/getDataInputSerach")
        .then(response => {
          // this.$store.commit("IS_LOADING", false)
          this.allStatus = response.data.status
          // console.log('status', response.data)
          for (let status of this.allStatus) {
            this.allStatusOption.push({code: status.id, name: status.libelle_bo})
          }
          this.allTraitements = response.data.traitements
          let traitementPrincipaux = response.data.traitements.reduce((res,traitement) => {
            if (traitement.type === 'Principal') {
              res.push(traitement);
            }
            return res;
          },[]);
          let traitementSecondaire = response.data.traitements.reduce((res,traitement) => {
            if (traitement.type === 'Secondaire') {
              res.push(traitement);
            }
            return res;
          },[]);
          let optionsPrincipaux = [];
          for (let traitement of traitementPrincipaux) {
            optionsPrincipaux.push({value: traitement.id, text: traitement.libelle})
          }
          this.traitementsOptions.push({label: 'Traitements principaux', options: optionsPrincipaux})
          let optionsSecondaires = [];
          for (let traitement of traitementSecondaire) {
            optionsSecondaires.push({value: traitement.id, text: traitement.libelle})
          }
          optionsSecondaires.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
          this.traitementsOptions.push({label: 'Traitements secondaires', options: optionsSecondaires})
          // for (let traitement of response.data.traitements) {
          //   this.traitementsOptions.push({value: traitement.id, text: traitement.libelle})
          // }
          this.allCanals = response.data.canals;
          for(let canal of response.data.canals){
            this.allCanalsOptions.push({code: canal.id, name: canal.libelle})
          }
          for(let type of response.data.types){
            this.allTypes.push({code: type.id, name: type.libelle})
          }
          for(let segment of response.data.segments){
            this.allSegments.push({code: segment.id, name: segment.libelle})
          }

          // On rajoute l'option N.D pour récupérer les dossiers dont le produit n'est pas déterminé
          this.allProduits.push({code: 'nd', name: 'n.d'});
          for(let produit of response.data.produits){
            this.allProduits.push({code: produit.id, name: produit.libelle})
          }

          let ess = [];
          let interpro = [];
          this.optionsProduit = [{secteur: 'ESS', produits: []}, {secteur: 'Interpro', produits: []}]
          for (let famille of response.data.produits) {
            let secteur = famille.secteur.split(',')
            if (secteur.indexOf('ess') > -1) {
              ess.push({code: famille.id, name: famille.libelle});
            } else {
              interpro.push({code: famille.id, name: famille.libelle});
            }
          }
          this.optionsProduit = [{secteur: 'ESS', produits: ess}, {secteur: 'Interpro', produits: interpro}]
          // console.log('this.optionsProduit',this.optionsProduit)

          for (let status of response.data.statusPrestij) {
            this.allStatusPrestij.push({code: status.id, name: status.libelle});
          }
          for (let segment of response.data.segmentsCommerciaux) {
            this.allSegmentsCommerciaux.push({code: segment.id, name: segment.libelle})
          }
          for (let delegation of response.data.delegations) {
            this.allDelegations.push({code: delegation.id, name: delegation.nom})
          }
          for (let groupSiren of response.data.groupSirens) {
            this.allGroupSirens.push({code: groupSiren.id, name: groupSiren.libelle})
          }
          for (let campagne of response.data.campagnes) {
            this.allCampagnes.push({code: campagne.id, name: campagne.libelle})
          }
          let user = getUser();
          let userOags = user.profil_active[0].oags.map(oag => oag.code);
          this.allOags = response.data.oags
          for (let oag of response.data.oags) {
            if (userOags.indexOf(oag.code) > -1) {
              this.oagOptions.push({code: oag.code, name: oag.code + ' (' + oag.structure.libelle + ')'});
            }
          }
          let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
          this.allOaps = response.data.oaps
          for (let oap of response.data.oaps) {
            if (userOaps.indexOf(oap.code) > -1) {
              this.oapOptions.push({code: oap.code, name: oap.code + ' (' + oap.structure.libelle + ')'});
            }
          }
          this.allTeams = response.data.equipes;
          for (let team of response.data.equipes) {
            this.teamOptions.push({value: team.id, text: team.libelle})
          }
          this.allFlags = response.data.flags;
          for (let flag of response.data.flags) {
            if (flag.type !== 'admin' || hasRule(adminRules.IS_ADMIN) || flag.libelle_technique === 'module_prev_auto') {
              let libelle = flag.type !== 'admin' || flag.libelle_technique === 'module_prev_auto' ? flag.libelle : flag.libelle+' (admin)';
              this.flagOptions.push({code: flag.id, name: libelle});
            }
          }
          this.allCodePtz = response.data.codesPtz;
          for (let code of response.data.codesPtz) {
            if(code.code_blocage) {
              this.codePtzOptions.push({code: code.code_blocage, name: code.code_blocage});
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.handleErrors(self);
        });
    },
    getSousStatus() {
      return new Promise((resolve, reject) => {
        this.allSousStatusOption = [];
        for (let statusId of this.selectedStatus) {
          for (let status of this.allStatus) {
            if (parseInt(statusId,10) === status.id) {
              for (let sousStatus of status.sous_statuts) {
                this.allSousStatusOption.push({code: sousStatus.id, name: sousStatus.libelle_bo});
              }
            }
          }
        }
        resolve();
      });
    },
    populateStatus() {
      this.populateData('status', 'allStatusOption', 'selectedStatus');
    },
    populateSousStatus() {
      this.populateData('sousStatus', 'allSousStatusOption', 'selectedSousStatus');
    },
    populateSegment() {
      this.populateData('segment', 'allSegments', 'selectedSegments');
    },
    populateCanal() {
      this.populateData('canal', 'allCanalsOptions', 'selectedCanals');
    },
    populateType() {
      this.populateData('type', 'allTypes', 'selectedTypes');
    },
    populateProduit() {
      this.populateData('produit', 'allProduits', 'selectedProduits');
    },
    populateStatusPrestij() {
      // console.log('this.selectedStatusPrestij',this.selectedStatusPrestij)
      this.populateData('statusPrestij', 'allStatusPrestij', 'selectedStatusPrestij');
    },
    populateSegmentCommerciaux() {
      this.populateData('segmentsCommerciaux', 'allSegmentsCommerciaux', 'selectedSegmentsCommerciaux');
    },
    populateDelegation() {
      this.populateData('delegations', 'allDelegations', 'selectedDelegations');
    },
    populateGroupSiren() {
      this.populateData('groupSirens', 'allGroupSirens', 'selectedGroupSirens');
    },
    populateCampagne() {
      this.populateData('campagnes', 'allCampagnes', 'selectedCampagnes');
    },
    populateOags() {
      this.oags = [];
      for (let id of this.selectedOags) {
        let name = "";
        for (let element of this.oagOptions) {
          if (element.code === id) {
            name = element.name
          }
        }
        this.oags.push({code: id, name: name});
      }
    },
    populateOaps() {
      this.oaps = [];
      for (let id of this.selectedOaps) {
        let name = "";
        for (let element of this.oapOptions) {
          if (element.code === id) {
            name = element.name
          }
        }
        this.oaps.push({code: id, name: name});
      }
    },
    populateFlag() {
      this.populateData('flag', 'flagOptions', 'selectedFlags');
    },
    populateTypeUrgence() {
      this.typeUrgence = [];
      for (let libelleTechnique of this.selectedTypesUrgences) {
        let name = "";
        for (let element of this.typeUrgenceOptions) {
          if (element.code === libelleTechnique) {
            name = element.name
          }
        }
        this.typeUrgence.push({code: libelleTechnique, name: name});
      }
    },
    populateCodePtz() {
      this.codesPtz = [];
      for (let code of this.selectedCodePtz) {
        let name = "";
        for (let element of this.codePtzOptions) {
          if (element.code === code) {
            name = element.name
          }
        }
        this.codesPtz.push({code: code, name: name});
      }
    },
    clearForm() {
      this.balId = ''
      this.basketId = ''
      this.nir = ''
      this.idpp = ''
      this.gestionnaire = ''
      this.gestionnaireNom = ''
      this.gestionnairePrenom = ''
      this.date_du = ''
      this.date_au = ''
      this.date_sinistre_du = ''
      this.date_sinistre_au = ''
      this.nom = ''
      this.prenom = ''
      this.rar = ''
      this.dossierIds = ''
      this.contactEmail = ''
      this.onlyOneCritere = false
      this.status = []
      this.selectedStatus = []
      this.sousStatus = []
      this.selectedSousStatus = []
      this.produit = []
      this.selectedProduits = []
      this.segment = []
      this.selectedSegments = []
      this.canal = []
      this.selectedCanals = []
      this.type = []
      this.selectedTypes = []
      this.delegations = []
      this.selectedDelegations = []
      this.statusPrestij = []
      this.selectedStatusPrestij = []
      this.segmentsCommerciaux = []
      this.selectedSegmentsCommerciaux = []
      this.groupSirens = []
      this.selectedGroupSirens = []
      this.campagnes = []
      this.selectedCampagnes = []
      this.oags = []
      this.selectedOags = []
      this.oaps = []
      this.selectedOaps = []
      this.selectedTeam = ''
      this.siren = ''
      this.nic = ''
      this.selectedTraitementId = ''
      // this.traitementId = ''
      // this.statusTraite = ''
      // this.modeVisualisation = ''
      this.alerte = ''
      this.errors.critere = ''
      this.errors.traitement = ''
      this.regleCumul = ''
      this.nomBeneficiaire = ''
      this.typePopulation = 'Tous'
      this.typeAffiliationSalarie = 'Tous'
      this.nbDossierNir = 0
      this.exclureBpij = ''
      this.flag = []
      this.selectedFlags = []
      this.typeUrgence = ''
      this.selectedTypesUrgences = []
      this.exclureGroupeSiren = ''
      this.exclureDateSinistre = ''
      this.numeroEvenementNsi = ''
    },
    async onSearchGestionnaire(search) {
      let self = this
      const lettersLimit = 2

      this.noData = false
      if (search.length < lettersLimit) {
        this.gestionnaires = []
        this.loadingGestionnaire = false
        return
      }
      this.loadingGestionnaire = true

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        this.$axios
          .get('/espaceGestion/gestionnaire/autocompleteRecherche?query='+search+'&type=all&for=recherche')
          .then(response => {
            // console.log(response)
            this.loadingGestionnaire = false
            this.gestionnaires = response.data
            if (!this.gestionnaires.length) this.noData = true
          })
          .catch(function(error) {
            console.log(error)
            self.loadingGestionnaire = false
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }, 500)
    },
    clearError() {
      this.errors.critere = '';
      this.errors.traitement = '';
      this.errors.dossierIds = '';
    },
    search() {
      if (this.validate()) {
        this.noSearch = 'search';
        this.balId = '';
        this.basketId = '';
        this.fromDashboard = '';
        this.$refs.dashboard_dossier_table.$refs.table.refresh();
        this.$root.$emit('bv::toggle::collapse', 'collapseRecherche');
        this.clearError();
        // On affecte à l'attribut traitementId qui sert pour les calculs et l'ouverture des dossiers le traitement qui a été sélectionné
        this.traitementId = this.selectedTraitementId;
      }
    },
    toggleAdvancedSearch() {
      this.advancedSearch ? this.clearForm() : ''
      // this.clearForm()
      this.advancedSearch = !this.advancedSearch
    },
    save() {
      // console.log('this.selectedCampagnes  Recherche : ', this.selectedCampagnes);
      this.$router.push({
        path: '/espace-gestion/corbeille/accueil',
        query: {
          status: this.selectedStatus,
          sousStatus: this.selectedSousStatus,
          traitementId: this.selectedTraitementId,
          gest: this.gestionnaire,
          gestNom: this.gestionnaireNom,
          gestPrenom: this.gestionnairePrenom,
          bal: this.balId,
          nir: this.nir,
          id_pp: this.idpp,
          dd: this.date_du,
          da: this.date_au,
          dsd: this.date_sinistre_du,
          dda: this.date_sinistre_au,
          nom: this.nom,
          prenom: this.prenom,
          segment: this.selectedSegments,
          canal: this.selectedCanals,
          produit: this.selectedProduits,
          type: this.selectedTypes,
          segmentsCommerciaux: this.selectedSegmentsCommerciaux,
          delegations: this.selectedDelegations,
          statusPrestij: this.selectedStatusPrestij,
          groupSirens: this.selectedGroupSirens,
          siren: this.siren,
          nic: this.nic,
          campagnes: this.selectedCampagnes,
          oags: this.selectedOags,
          oaps: this.selectedOaps,
          team: this.selectedTeam,
          regleCumul: this.regleCumul,
          nomBeneficiaire: this.nomBeneficiaire,
          nbDossierNir : this.nbDossierNir,
          flag: this.selectedFlags,
          typeUrgence: this.selectedTypesUrgences,
          codesPtz: this.selectedCodePtz
        }
      });
    },
    validate() {
      let error = false;
      let critereSimple = ['nir', 'idpp','gestionnaire','date_du', 'date_au','date_sinistre_du', 'date_sinistre_au',  'nom', 'prenom', 'rar', 'dossierIds', 'siren', 'nic', 'selectedTeam', 'regleCumul', 'nomBeneficiaire', 'typePopulation','typeAffiliationSalarie','nbDossierNir', 'exclureBpij','numeroEvenementNsi'];
      let critereMultiple = ['selectedStatus', 'selectedGroupSirens', 'selectedProduits', 'selectedStatusPrestij', 'selectedDelegations', 'selectedCanals', 'selectedTypes', 'selectedSegments', 'selectedCampagnes', 'selectedSegmentsCommerciaux', 'selectedOags', 'selectedOaps', 'selectedFlags', 'selectedTypesUrgences', 'selectedCodePtz'];
      // Mise à zéro du critère de recherche unique
      this.onlyOneCritere = false;

      if (this.balId === ''
        && this.nir === ''
        && this.idpp === ''
        && this.gestionnaire === ''
        && this.date_du === ''
        && this.date_au === ''
        && this.date_sinistre_du === ''
        && this.date_sinistre_au === ''
        && this.nom === ''
        && this.prenom === ''
        && this.rar === ''
        && this.dossierIds === ''
        && this.siren === ''
        && this.nic === ''
        && this.contactEmail === ''
        && this.selectedTeam === ''
        && this.selectedStatus.length === 0
        && this.selectedGroupSirens.length === 0
        && this.selectedProduits.length === 0
        && this.selectedStatusPrestij.length === 0
        && this.selectedDelegations.length === 0
        && this.selectedCanals.length === 0
        && this.selectedTypes.length === 0
        && this.selectedSegments.length === 0
        && this.selectedCampagnes.length === 0
        && this.selectedOags.length === 0
        && this.selectedOaps.length === 0
        && this.selectedCodePtz.length === 0
        && this.selectedSegmentsCommerciaux.length === 0
        && this.regleCumul === ''
        && this.nomBeneficiaire === ''
        && this.typePopulation === 'Tous'
        && this.typeAffiliationSalarie === 'Tous'
        && this.nbDossierNir === 0
        && this.selectedFlags.length === 0
        && this.selectedTypesUrgences.length === 0
        && this.numeroEvenementNsi === '') {
        error = true;
        this.errors.critere = 'Vous devez sélectionner au moins un critère de recherche';
      }

      this.dossierIds = this.dossierIds.trim();

      if (parseInt(this.dossierIds,10) > 2147483647) {
        error = true;
        this.errors.critere = 'Le numéro de dossier recherché est invalide, probablement un nir copié dans le champ "N° Dossier"';
      }
      let countCritere = 0;
      let critereDossier = false;
      let critereNir = false;
      let critereIdpp = false;
      let critereNom = false;
      let criterePrenom = false;
      let critereNumeroEvenementNsi = false;
      let critereRar = false;
      let critereNbDossierNir = false;
      let critereExclureBpij = false;
      let critereDateDu = false;
      let critereDateAu = false;

      this.dossierIds = this.dossierIds.replace(/\s/g, '');
      this.dossierIds = this.dossierIds.replace(/,\s*$/, "");
      if(this.dossierIds !== ''){
        // var reg = /^([0-9]+$)|(([0-9]{1,},){1,}[0-9]{1,}$)/
        var reg = /^[0-9,]+$/
        if(!reg.test(this.dossierIds)){
          error = true;
         this.errors.dossierIds = 'Numéro(s) de dossier(s) invalide';
        }
      }

      countCritere += critereSimple.reduce((res, critere) => {
        if (this[critere] !== '') {
          // console.log('critereSimple',critere,this[critere])
          if (critere === 'nir') { critereNir = true }
          if (critere === 'idpp') { critereIdpp = true }
          if (critere === 'dossierIds') { critereDossier = true }
          if (critere === 'nom') { critereNom = true }
          if (critere === 'prenom') { criterePrenom = true }
          if (critere === 'rar') { critereRar = true }
          if (critere === 'date_du') { critereDateDu = true }
          if (critere === 'date_au') { critereDateAu = true }
          // if (critere === 'nbDossierNir') { critereNbDossierNir = true }
          if (critere === 'exclureBpij') { critereExclureBpij = true }
          if (critere === 'numeroEvenementNsi') { critereNumeroEvenementNsi = true }

          if (critere !== 'nbDossierNir' && critere !== 'typePopulation' && critere !== 'typeAffiliationSalarie') {
            return res + 1;
          } else {
            if (critere === 'nbDossierNir' && this[critere] !== 0) {
              critereNbDossierNir = true
              return res + 1;
            } else if (critere === 'typePopulation' && this[critere] !== 'Tous') {
              critereNbDossierNir = true
              return res + 1;
            }
          }

        }
        return res;
      }, 0);
      // console.log('countCritere',countCritere)
      countCritere += critereMultiple.reduce((res, critere) => {
        return this[critere].length !== 0 ? res + 1 : res;
      }, 0);

      // on calcule les cas de critère unique (nir, idpp, num dossier, nom ou nom + prenom)
      // On ajoute les champ date à la possibilité de critère unique
      if ((countCritere === 1 && critereNir && this.selectedTraitementId === '') || (countCritere === 3 && critereNir && critereDateDu && critereDateAu && this.selectedTraitementId === '') || (countCritere === 2 && ((critereNir && critereDateAu) || (critereNir && critereDateDu)) && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'nir';
      }
      if ((countCritere === 1 && critereIdpp && this.selectedTraitementId === '') || (countCritere === 3 && critereIdpp && critereDateDu && critereDateAu && this.selectedTraitementId === '') || (countCritere === 2 && ((critereIdpp && critereDateAu) || (critereIdpp && critereDateDu)) && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'idpp';
      }
      if ((countCritere === 1 && critereDossier && this.selectedTraitementId === '') || (countCritere === 3 && critereDossier && critereDateDu && critereDateAu && this.selectedTraitementId === '') || (countCritere === 2 && ((critereDossier && critereDateAu) || (critereDossier && critereDateDu)) && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'dossier';
      }
      if (
          (countCritere === 1 && critereNom && this.selectedTraitementId === '')
          || (countCritere === 2 && critereNom && criterePrenom && this.selectedTraitementId === '')
          || (countCritere === 2 && ((critereNom && critereDateDu) || (critereNom && critereDateAu)) && this.selectedTraitementId === '')
          || (countCritere === 3 && ((critereNom && criterePrenom && critereDateDu) || (critereNom && criterePrenom && critereDateAu)) && this.selectedTraitementId === '')
          || (countCritere === 4 && critereNom && criterePrenom && critereDateDu && critereDateAu && this.selectedTraitementId === '')
        ) {
        this.onlyOneCritere = 'nom';
      }
      if ((countCritere === 1 && critereRar && this.selectedTraitementId === '') || (countCritere === 3 && critereRar && critereDateDu && critereDateAu && this.selectedTraitementId === '') || (countCritere === 2 && ((critereRar && critereDateAu) || (critereRar && critereDateDu)) && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'rar';
      }
      if ((countCritere === 1 && critereNumeroEvenementNsi && this.selectedTraitementId === '') || (countCritere === 3 && critereNumeroEvenementNsi && critereDateDu && critereDateAu && this.selectedTraitementId === '') || (countCritere === 2 && ((critereNumeroEvenementNsi && critereDateAu) || (critereNumeroEvenementNsi && critereDateDu)) && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'numeroEvenementNsi';
      }

      if ((countCritere === 1 && critereNbDossierNir && this.selectedTraitementId === '') || (countCritere === 2 && critereNbDossierNir && critereExclureBpij && this.selectedTraitementId === '')) {
        this.onlyOneCritere = 'nbDossierNir';
      }

      // if ((this.selectedTraitementId === '' && countCritere > 1) ||  (this.selectedTraitementId === '' && countCritere === 1 && !critereNir && !critereDossier)) {
      if (((this.selectedTraitementId === '' && countCritere > 5) ||  (this.selectedTraitementId === '' && countCritere === 1 && !this.onlyOneCritere) ||  (this.selectedTraitementId === '' && countCritere === 2 && !this.onlyOneCritere) ||  (this.selectedTraitementId === '' && countCritere === 3 && !this.onlyOneCritere) ||  (this.selectedTraitementId === '' && countCritere === 4 && !this.onlyOneCritere)) && !critereNbDossierNir) {
        error = true;
        this.errors.traitement = 'Vous devez sélectionner le traitement désiré';
      }
      return !error;
    },
    canAccesDashboard() {
      return hasRule(rules.CAN_ACCESS_DASHBOARD_DOSSIER)
    },
    canAccessDashboardQualification() {
      return hasRule(rules.CAN_QUALIFY_DOSSIER) && hasRule(rules.CAN_ACCESS_DASHBOARD_DOSSIER)
    },
    canAccessDashboardGestion() {
      return hasRule(rules.CAN_MANAGE_DOSSIER) && hasRule(rules.CAN_ACCESS_DASHBOARD_DOSSIER)
    },
    canCreateBasket() {
      return hasRule(rules.CAN_CREATE_BASKET_DOSSIER)
    },
    canCreateBasketForAll() {
      return hasRule(rules.CAN_CREATE_BASKET_FOR_ALL_DOSSIER)
    },
    populateData(data, allData, selectedData) {
      this[data] = [];
      for (let id of this[selectedData]) {
        let name = "";
        for (let element of this[allData]) {
          if (element.code === parseInt(id)) {
            name = element.name
          }
        }
        this[data].push({code: id, name: name});
      }
    },
    handleErrors(self) {
      self.$store.commit('IS_LOADING', false)
      self.$swal({
        position: 'top',
        type: 'error',
        title: 'Attention !!',
        text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
        showConfirmButton: false,
        timer: 5000
      })
    },
    getReglesCumul() {
      let self = this;
      this.$axios
        .get("/espaceGestion/dossier/getReglesCumul")
        .then(response => {
          this.allRegleCumul = response.data.data;
          this.allRegleCumulOption.push({value: 'tous', text: 'Toutes les règles de cumul'});
          for (let regleCumul of response.data.data) {
            this.allRegleCumulOption.push({value: regleCumul.libelle_technique, text: regleCumul.libelle});
          }
        })
        .catch(() => {
          self.handleErrors(self);
        });
    },
    displayNbDossierNir() {
      if(this.nbDossierNir === 0 || this.nbDossierNir == 0){
        return "Tous";
      }else if(this.nbDossierNir == 5){
        return '1 seul';
      }else if(this.nbDossierNir == 10){
        return '2 à 5';
      }else if(this.nbDossierNir == 15){
        return '2 et +';
      }else{
        return (this.nbDossierNir -15)  + ' et +';
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .dashboard {
    background-color: #FFFFFF;
    display: inline-block;
  }
  .dashboard th, .dashboard td {
    padding: 0.25rem 0.75rem;
    border-left: 1px solid #DFDFDF;
    text-align: center;
  }
  .dashboard th:last-child, .dashboard td:last-child {
    border-right: 1px solid #DFDFDF;
  }
  .dashboard tr:last-child td {
    border-bottom: 1px solid #DFDFDF;
  }
  .dashboard tr.row-separateur td {
    border-top: 1px solid #DFDFDF;
    border-bottom: 1px solid #DFDFDF;
    border-right: none;
    border-left: none;
  }
  .dashboard tr:last-child td.col-separateur, .dashboard tr.row-separateur td.col-separateur, td.col-separateur {
    border-top: none;
    border-bottom: none;
  }
  td.disabled {
    background-color: #DFDFDF;
  }
  .dashboard tr:last-child td.btl-only {
    border: none;
    border-top: 1px solid #DFDFDF;
    border-left: 1px solid #DFDFDF;
  }
  .footer {
    padding-top: 0.5rem;
  }
  .borded-top {
    border-top: 1px solid #DFDFDF;
  }
  .headerDashboard {
    background-color: #87b7cd;
    min-width: 100px;
  }
  .headerDashboard-light {
    background-color: #bdeaff;
    min-width: 100px;
  }
  .headerDashboard.firstColumn {
    min-width: 250px;
  }
  .headerDashboardAlert {
    background-color: #cd8787;
  }
  .basketDashboard {
    background-color: #cde2ec;
  }
  .dashboard .basketDashboard.action {
    padding: 0.25rem 0.1rem;
    border-left: none;
  }
  .dashboard-card {
    margin-bottom: 0.5rem;
  }
  input.input_date:invalid {
    /*content: '✖';
    padding-left: 5px;*/
    border: solid 1px #ff1744;
  }
  .card-smallHeader {
    padding: 0.15rem 0.75rem;
    border-bottom: 1px solid #DFDFDF;
    background-color: #ECECEC;
  }
  .form-control.inline, .inline {
    width: auto;
    display: inline-block;
  }
  .card-body.small-padding {
    padding: 0.75rem 0.75rem 0.5rem 0.75rem;
  }
 .card-body.xsmall-padding {
    padding: 0.5rem;
  }
  .loading-indicator {
    width: 20px;
  }
  #collapseRecherche fieldset {
    margin-bottom: 0.25rem;
  }
</style>
